import { AfterViewInit, Component, Input } from '@angular/core';
import { RestApiService } from '../../services/rest-api.service';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { environment } from '../../../../environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { ClockRegistrationElaboration, ClockRegistrationElaborationDetail } from '../../models/clock-registration-elaboration';
import DataSource from 'devextreme/data/data_source';
import { EditorPreparingEvent } from 'devextreme/ui/data_grid';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import DataGrid from "devextreme/ui/data_grid";
import { DxTextAreaTypes } from 'devextreme-angular/ui/text-area';
import { DxLookupTypes } from 'devextreme-angular/ui/lookup';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'app-clock-registration-validation-detail',
    templateUrl: './clock-registration-validation-detail.component.html',
    styleUrl: './clock-registration-validation-detail.component.scss',
    providers: [],
    standalone: false
})
export class ClockRegistrationValidationDetailComponent implements AfterViewInit {
  @Input() key: number | undefined;
  @Input() rowData: ClockRegistrationElaboration | undefined;

  dataGridWorkersInstance: DataGrid | undefined;
  dataGridToolsInstance: DataGrid | undefined;
  dataGridAttachmentInstance: DataGrid | undefined;

  costoVisible = true;
  approveShowStartStop = false;

  selectedForcedCost: string | null = null;
  availableCostsForSite: any[] = [];

  displayCostFn = (item: any) => item ? `${item.costCode} - ${item.costDescription}` : '';

  
  costForcedOptions: any;
  availableCosts: any[] = [];


  saveWorkersGridInstance(e: DxDataGridTypes.InitializedEvent) {
    this.dataGridWorkersInstance = e.component;
  }

  saveToolsGridInstance(e: DxDataGridTypes.InitializedEvent) {
    this.dataGridToolsInstance = e.component;
  }

  saveAttachmentGridInstance(e: DxDataGridTypes.InitializedEvent) {
    this.dataGridAttachmentInstance = e.component;
  }

  faseVisible = true;

  private unsubscribe: Subject<void> = new Subject<void>();

  backendURL: string = environment.ApiUrl + '/api';

  registrationDetail: ClockRegistrationElaborationDetail;
  tenantId: number;
  errorMessage = "";
  errorVisible = false;

  cantiereEditorOptions: DxLookupTypes.Properties;
  faseEditorOptions: DxLookupTypes.Properties;

  workersDataSource: any;
  toolsDataSource: any;
  attachmentsDataSource: any;
  notesEditorOptions: DxTextAreaTypes.Properties = {
    autoResizeEnabled: true,
    inputAttr: {
      'aria-label': 'Notes'
    }
  };

  lookupErrorData = [
    { id: 1, name: 'Ok' },
    { id: 2, name: 'Avviso' },
    { id: 3, name: 'Errore' },
  ];
    
  constructor(private restApi: RestApiService) {

    this.tenantId = restApi.readTenantId();

    this.registrationDetail = {
      tenantId: this.tenantId,
      userRegistrationID: 0,
      allegati: 0,
      mezzi: 0,
      mezziAssociatiAiDipendenti: 0,
      notes: null,
      workingPhaseCode: null,
      workingPhaseDescription: null
    };

    const cantiereDataSource = this.restApi.getConstructionSitesDataSorce()

    this.cantiereEditorOptions = {
      dataSource: cantiereDataSource,
      searchEnabled: true,
      displayExpr: "constructionSiteDescription",
      valueExpr: "constructionSiteCode",
      showClearButton: true,
      searchExpr: "constructionSiteDescription",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare il cantiere",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };

    this.faseEditorOptions = {
      dataSource: this.restApi.getConstructionPhasesDataSorce(),
      searchEnabled: true,
      displayExpr: "constructionPhaseDescription",
      valueExpr: "constructionPhaseCode",
      showClearButton: true,
      searchExpr: "constructionPhaseDescription",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare la fase",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };

    this.restApi.getOptions().pipe(takeUntil(this.unsubscribe)).subscribe(
      o => {
        this.costoVisible = (o?.cost ?? 0) >= 1;
        this.faseVisible = (o?.workingPhase ?? 0) >= 1;
        this.approveShowStartStop = o?.approveShowStartStop ?? false;
      });
  }

  ngAfterViewInit() {
    this.restApi.getOptions().pipe(takeUntil(this.unsubscribe)).subscribe(o => this.faseVisible = (o?.workingPhase ?? 0) >= 1);

    this.workersDataSource = new DataSource({
      store: AspNetData.createStore({
        key: 'registrationId',
        loadParams: { userRegistrationId: this.key },
        loadUrl: `${this.backendURL}/ClockRegistrationElaborations/GetWorkers`,
        updateUrl: this.backendURL + '/ClockRegistrationElaborations/PutWorker',
        deleteUrl: this.backendURL + '/ClockRegistrationElaborations/DeleteWorker',
      }),

    });

    this.toolsDataSource = new DataSource({
      store: AspNetData.createStore({
        key: 'registrationId',
        loadParams: { userRegistrationId: this.key },
        loadUrl: `${this.backendURL}/ClockRegistrationElaborations/GetTools`,
        updateUrl: this.backendURL + '/ClockRegistrationElaborations/PutTool',
        deleteUrl: this.backendURL + '/ClockRegistrationElaborations/DeleteTool',
      }),
    });

    this.attachmentsDataSource = new DataSource({
      store: AspNetData.createStore({
        key: 'attachmentId',
        loadParams: { userRegistrationId: this.key },
        loadUrl: `${this.backendURL}/ClockRegistrationElaborations/GetAttachments`,
        deleteUrl: this.backendURL + '/ClockRegistrationElaborations/DeleteAttachment',
      }),
    });

    if (this.key) {
      this.restApi.getClockRegistrationElaborationDetail(this.key).pipe(takeUntil(this.unsubscribe)).subscribe((detail) => {
        this.registrationDetail = detail as any;

        // aggiorno la lista filtrata dopo avere il constructionSiteCode
        //this.updateAvailableCostsForSite();
        
        this.registrationDetail = detail;



        this.restApi.getCostsGeneral().pipe(takeUntil(this.unsubscribe)).subscribe((costs: any[]) => {
          this.availableCosts = costs ?? [];

          this.updateAvailableCostsForSite();
          this.costForcedOptions = {
            dataSource: this.availableCosts,
            displayExpr: (item: any) => item.costCode + ' - ' + item.costDescription,
            valueExpr: 'costCode',
            placeholder: 'Seleziona codice costo',
            searchEnabled: true,
            showClearButton: true
          };
        });
        
      });
    }
  }

  private updateAvailableCostsForSite(): void {
    // se non abbiamo detail non filtro
    const siteCode = (this.registrationDetail as any)?.constructionSiteCode;
    // se gli elementi cost contengono la proprietà constructionSiteCode (se presente)
    if (siteCode && this.availableCosts.length > 0 && this.availableCosts.some(c => (c as any).constructionSiteCode !== undefined)) {
      this.availableCostsForSite = this.availableCosts.filter(c => c.constructionSiteCode === siteCode);
    } else {
      // fallback: mostra tutti i costi del tenant
      this.availableCostsForSite = this.availableCosts;
    }
  }


  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onEditorPreparing(e: EditorPreparingEvent) {
    if (e.parentType === "dataRow") {
      e.editorOptions.onFocusIn = (function (args: { element: { querySelector: (arg0: string) => { (): any; new(): any; select: { (): void; new(): any; }; }; }; }): void {
        console.log(args.element);
        args.element.querySelector(".dx-texteditor-input").select();
      });

      if (e.dataField === 'startTime' || e.dataField === 'endTime') {
        e.editorOptions.onKeyDown = (args: any) => {
          const event: KeyboardEvent = args.event;
          const key = event.key;
          if (key.length === 1 && !/[\d:.]/.test(key)) {
            event.preventDefault();
          }
        };
      }
    }
  }

  onOpenClick = (e: DxDataGridTypes.ColumnButtonClickEvent) => {
    if (e.row?.data) {
      const fileName = environment.ApiUrl + "/" + e.row?.data.fileUrl;
      window.open(fileName, "_blank");
    }

    if (e.event)e.event.preventDefault();
  };

  private normalizeTime(value: string): string | null {
    if (value === null || value === undefined || value === '') return '';
    const trimmed = value.replace(/\./g, ':').trim();
    if (/^\d{1,2}$/.test(trimmed)) {
      const h = Number(trimmed);
      if (h >= 0 && h <= 23) return String(h).padStart(2, '0') + ':00';
      return null;
    }
    const match = /^(\d{1,2}):(\d{1,2})$/.exec(trimmed);
    if (match) {
      const h = Number(match[1]);
      const m = Number(match[2]);
      if (h >= 0 && h <= 23 && m >= 0 && m <= 59) {
        return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
      }
    }
    return null;
  }

  setCellValueInizio = (newData: any, value: string, currentRowData: any) => {
    const normalized = this.normalizeTime(value);
    if (normalized === null) {
      notify('Formato ora non valido. Atteso HH:mm (es. 08:30).', 'error', 3000);
      return;
    }
    newData.startTime = normalized;
    const endTime = currentRowData.endTime;
    if (normalized && endTime) {
      newData.workedHours = this.calculateWorkedHours(normalized, endTime);
    }
  };

  setCellValueFine = (newData: any, value: string, currentRowData: any) => {
    const normalized = this.normalizeTime(value);
    if (normalized === null) {
      notify('Formato ora non valido. Atteso HH:mm (es. 17:00).', 'error', 3000);
      return;
    }
    newData.endTime = normalized;
    const startTime = currentRowData.startTime;
    if (startTime && normalized) {
      newData.workedHours = this.calculateWorkedHours(startTime, normalized);
    }
  };

  formatTime = (cellInfo: { value: string }) => {
    if (!cellInfo.value) return '';
    return cellInfo.value.substring(0, 5);
  };

  private calculateWorkedHours(startTime: string, endTime: string): number {
    const [sh, sm] = startTime.split(':').map(Number);
    const [eh, em] = endTime.split(':').map(Number);
    const startMin = sh * 60 + sm;
    const endMin = eh * 60 + em;
    let totalMinutes = endMin - startMin;
    const crossesMidnight = totalMinutes < 0;
    if (crossesMidnight) totalMinutes += 24 * 60;

    const entirelyInDayWindow = !crossesMidnight
      && startMin >= 6 * 60
      && endMin <= 22 * 60;
    if (entirelyInDayWindow && totalMinutes >= 6.5 * 60) {
      totalMinutes -= 60;
    }

    const rounded = Math.round(totalMinutes / 15) * 15;
    return Math.round((rounded / 60) * 100) / 100;
  }

  saveClick = () => {

    const forced = this.selectedForcedCost;
    const userRegId = this.registrationDetail?.userRegistrationID;

    const updateAndSave = () => {
      this.restApi.putClockRegistrationElaborationDetail(this.registrationDetail).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.dataGridWorkersInstance?.refresh();
        this.dataGridToolsInstance?.refresh();
      });
    };

    if (forced && userRegId) {
      this.restApi.putSetCostForRegistration(userRegId, forced).pipe(takeUntil(this.unsubscribe)).subscribe({
        next: () => updateAndSave(),
        error: () => {
          console.error('Errore forzatura costi');
          updateAndSave(); // comunque salva anche le altre modifiche
        }
      });
    } else {
      updateAndSave();
    }

  };

  saveApproveClick = () => {

    const forced = this.selectedForcedCost;
    const userRegId = this.registrationDetail?.userRegistrationID;

    const updateAndApprove = () => {
      this.restApi.putClockRegistrationElaborationDetailApprove(this.registrationDetail).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.dataGridWorkersInstance?.refresh();
        this.dataGridToolsInstance?.refresh();
      });
    };


    if (forced && userRegId) {
      this.restApi.putSetCostForRegistration(userRegId, forced).pipe(takeUntil(this.unsubscribe)).subscribe({
        next: () => updateAndApprove(),
        error: () => {
          console.error('Errore forzatura costi');
          updateAndApprove();
        }
      });
    } else {
      updateAndApprove();
    }

  };
}
